// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__yNpJ9","location":"Header_location__mSyM-"};